import React, { useState } from 'react';
import { Button, Form, Input, InputNumber, message, Modal, notification } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import FormLabel from '../../../components/FormLabel';
import NormalFormLabel from '../../../components/NormalFormLabel';
import { useMutation } from '@tanstack/react-query';
import CustomSelect from '../../../components/CustomSelect';
import { addUpdatePartnerRequest } from '../../../services/partnerRequest';
import { validatePhoneNumber } from '../../../utils/validate';
import { LIST_STATUS_PARTNER } from '../../../constants/appSelect';

const ThemDoiTac = ({ Confirm, visible, refetchDataPartners }) => {
  const { mutate: mutateCreatePartner, isPending: isLoadingCreatePartner } = useMutation({
    mutationFn: addUpdatePartnerRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Thêm mới người dùng thành công!',
        });
        refetchDataPartners();
      } else {
        notification.error({
          message: data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({ message: error?.data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!' });
    },
  });

  const handleCancel = () => {
    Confirm(false);
  };

  const onFinish = (values) => {
    mutateCreatePartner(values);
    handleCancel();
  };

  return (
    <Modal title="Thêm đối tác" open={visible} onCancel={handleCancel} footer={null} width={840}>
      <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Form.Item
          label={<FormLabel text="Tên đối tác" />}
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên đối tác' }]}
        >
          <Input allowClear placeholder="Nhập tên đối tác......" />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="Mô tả" />} name="description">
          <Input allowClear placeholder="Nhập mô tả......" />
        </Form.Item>

        <Form.Item
          label={<NormalFormLabel text="Số điện thoại" />}
          name="phone"
          rules={[
            () => ({
              validator(_, value) {
                if (value && !validatePhoneNumber(value)) {
                  return Promise.reject(new Error('Số điện thoại không đúng định dạng'));
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input allowClear type="number" placeholder="Nhập số điện thoại......" />
        </Form.Item>

        <Form.Item
          label={<NormalFormLabel text="Email" />}
          name="email"
          rules={[{ type: 'email', message: 'Email không đúng định dạng' }]}
        >
          <Input allowClear placeholder="Nhập email......" />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="Địa chỉ" />} name="address">
          <Input allowClear placeholder="Nhập địa chỉ......" />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Trạng thái" />}
          name="status"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
        >
          <CustomSelect placeholder="Chọn trạng thái" options={[LIST_STATUS_PARTNER[0], LIST_STATUS_PARTNER[1]]} />
        </Form.Item>

        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>
            <CloseOutlined /> Hủy bỏ
          </Button>
          <Button loading={isLoadingCreatePartner} type="primary" htmlType="submit">
            <SaveOutlined /> Lưu lại
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ThemDoiTac;
